import type { ReactNode } from "react";
import { Footer } from "../Footer";
import { Header } from "../Header";
import { SiteBackground } from "../SiteBackground";
import { pageBg } from "../ui";

interface SiteLayoutProps {
	children: ReactNode;
	/** Header floats over hero — used on the top page */
	headerOverlay?: boolean;
}

/** Unified page chrome — header, brand background, footer */
export function SiteLayout({ children, headerOverlay = false }: SiteLayoutProps) {
	return (
		<SiteBackground>
			<div className={`flex min-h-screen flex-col ${pageBg}`}>
				<Header overlay={headerOverlay} />
				{children}
				<Footer />
			</div>
		</SiteBackground>
	);
}
